import React, { Component } from 'react';
import CreativeStats from 'profile/containers/stats';
import ClientStats from 'profile/containers/client_stats';

/**
 * Client and/or creative stats.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class AllStats extends Component {
  constructor(props) {
    super(props);

    /* only used if profile is both client and creative */
    this.state = { showingForClient: false };
    this.toggleStats = this.toggleStats.bind(this);
  }

  toggleStats() {
    this.setState({ showingForClient: !this.state.showingForClient });
  }

  render() {
    const { showingForClient } = this.state;
    const { is_creative, is_client } = this.props;
    const isBoth = is_creative && is_client;
    return (
      <div className="all-stats">
        { ((isBoth && showingForClient) || (!isBoth && is_client)) && <ClientStats/> }

        { ((isBoth && !showingForClient) || (!isBoth && is_creative)) && <CreativeStats/> }
        
        {isBoth &&
        <button className="btn btn-sm btn-text stats-toggle" onClick={this.toggleStats}>
          {showingForClient? 'Creative': 'Client'} Stats
        </button>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./profile/components/all_stats.jsx